/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseCalcFieldToken } from './DatabaseCalcFieldToken';
import {
    DatabaseCalcFieldTokenFromJSON,
    DatabaseCalcFieldTokenFromJSONTyped,
    DatabaseCalcFieldTokenToJSON,
} from './DatabaseCalcFieldToken';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseCombinedTextField
 */
export interface DatabaseCombinedTextField extends DatabaseField {
    /**
     * 
     * @type {Array<DatabaseCalcFieldToken>}
     * @memberof DatabaseCombinedTextField
     */
    formula?: Array<DatabaseCalcFieldToken>;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCombinedTextField
     */
    displayDirection?: DatabaseCombinedTextFieldDisplayDirectionEnum;
    /**
     * Nichts anzeigen, solange eines der zusammengefuehrten Felder leer ist.
     * NACHGEZOGEN VOM BERECHNUNGSFELD (Vorgabe des Betreibers 02.10.2026: "Beim zusammengesetzten Feld muss die Funktion aus dem Feldtyp Berechnung nachgezogen werden").
     * WOFUER: Ein zusammengesetztes Feld laesst leere Teile stillschweigend weg und fuegt den Rest zusammen. Aus "Album" und "Interpret" wird dann bei fehlendem Album allein der Interpret -- und das sieht aus wie ein Album. Dieselbe Wurzel wie beim Rechenfeld, wo ein fehlender Wert als 0 einfloss und eine Zahl ergab, die wie ein Ergebnis aussieht.
     * NUR DIE UNMITTELBAREN BEZUEGE zaehlen. Verweist das Feld auf ein anderes zusammengesetztes Feld, entscheidet DIESES fuer sich, ob es leer ist -- Leere vererbt sich dann von selbst, weil sein Wert leer ankommt.
     * Fehlt der Wert, verhaelt sich das Feld wie bisher.
     * @type {boolean}
     * @memberof DatabaseCombinedTextField
     */
    hideWhenIncomplete?: boolean;
}


/**
 * @export
 */
export const DatabaseCombinedTextFieldDisplayDirectionEnum = {
    Horizontal: 'HORIZONTAL',
    Vertical: 'VERTICAL',
    DistributedLeft: 'DISTRIBUTED_LEFT',
    DistributedCenter: 'DISTRIBUTED_CENTER',
    DistributedRight: 'DISTRIBUTED_RIGHT'
} as const;
export type DatabaseCombinedTextFieldDisplayDirectionEnum = typeof DatabaseCombinedTextFieldDisplayDirectionEnum[keyof typeof DatabaseCombinedTextFieldDisplayDirectionEnum];


/**
 * Check if a given object implements the DatabaseCombinedTextField interface.
 */
export function instanceOfDatabaseCombinedTextField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCombinedTextFieldFromJSON(json: any): DatabaseCombinedTextField {
    return DatabaseCombinedTextFieldFromJSONTyped(json, false);
}

export function DatabaseCombinedTextFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCombinedTextField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'formula': !exists(json, 'formula') ? undefined : ((json['formula'] as Array<any>).map(DatabaseCalcFieldTokenFromJSON)),
        'displayDirection': !exists(json, 'displayDirection') ? undefined : json['displayDirection'],
        'hideWhenIncomplete': !exists(json, 'hideWhenIncomplete') ? undefined : json['hideWhenIncomplete'],
    };
}

export function DatabaseCombinedTextFieldToJSON(value?: DatabaseCombinedTextField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'formula': value.formula === undefined ? undefined : ((value.formula as Array<any>).map(DatabaseCalcFieldTokenToJSON)),
        'displayDirection': value.displayDirection,
        'hideWhenIncomplete': value.hideWhenIncomplete,
    };
}

